// extracted by mini-css-extract-plugin
export var header = "_ft-0";